import { useState, useEffect, createContext, useContext } from "react";
import { getAccessToken, setAccessToken, clearAccessToken, isAuthenticated } from "../utils/tokenStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [authenticated, setAuthenticated] = useState(isAuthenticated());

    const login = (accessToken) => {
        setAccessToken(accessToken);
        setAuthenticated(true);
    };

    const logout = () => {
        clearAccessToken();
        setAuthenticated(false);
    };

    useEffect(() => {
        setAuthenticated(isAuthenticated());
    }, []);

    return (
        <AuthContext.Provider value={{ authenticated, login, logout, getAccessToken }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within AuthProvider");
    }
    return context;
}
